import styled from "styled-components";

const S = {
    MasterDetailWrapper: styled.div`
        display: grid;
        grid-template-columns: 1.2fr 2fr;
        gap: 40px;
        width: 100%;
        max-width: 1400px;
        margin: 0 auto;
        padding: 0 40px;

        @media (max-width: 1024px) {
            grid-template-columns: 1fr;
            gap: 30px;
        }

        .left-column {
            display: flex;
            flex-direction: column;
            max-height: 600px;
            overflow-y: auto;
            padding-right: 15px;

            /* Hide scrollbar for an elegant look */
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */
            
            &::-webkit-scrollbar {
                display: none; /* Chrome, Safari and Opera */
            }

            .webinar-list {
                list-style: none;
                padding: 0;
                margin: 0;
                display: flex;
                flex-direction: column;
                gap: 15px;

                .list-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 20px 25px;
                    background: #fff;
                    border-radius: 12px;
                    border: 1px solid rgba(0,0,0,0.05);
                    cursor: pointer;
                    transition: all 0.3s ease;

                    .item-title {
                        font-size: 1.1em;
                        font-weight: 600;
                        color: #1a2b34;
                        transition: color 0.3s ease;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        padding-right: 15px;
                    }

                    .item-icon {
                        width: 24px;
                        height: 24px;
                        color: rgba(0,0,0,0.2);
                        transition: all 0.3s ease;
                        flex-shrink: 0;
                    }

                    &:hover, &.active {
                        background: #00A9C4;
                        border-color: #00A9C4;
                        transform: translateX(10px);
                        box-shadow: 0 10px 20px rgba(0, 169, 196, 0.2);

                        .item-title {
                            color: #fff;
                        }

                        .item-icon {
                            color: #fff;
                            transform: translateX(5px);
                        }
                    }
                }
            }
        }

        .right-column {
            display: flex;
            align-items: center;

            .detail-card {
                position: relative;
                width: 100%;
                background: #000;
                border-radius: 20px;
                overflow: hidden;
                box-shadow: 0 20px 40px rgba(0,0,0,0.15);
                cursor: pointer;
                transition: transform 0.3s ease, box-shadow 0.3s ease;

                &:hover {
                    transform: translateY(-5px) scale(1.02);
                    box-shadow: 0 25px 50px rgba(0, 169, 196, 0.3);
                }

                .iframe-wrapper {
                    position: relative;
                    width: 100%;
                    padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
                    
                    img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        opacity: 0.9;
                        transition: opacity 0.3s ease, transform 0.5s ease;
                    }

                    .gradient-overlay {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 70%;
                        background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 100%);
                        pointer-events: none;
                        z-index: 1;
                    }

                    .play-button-overlay {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 80px;
                        height: 80px;
                        background: rgba(0, 169, 196, 0.85);
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: white;
                        box-shadow: 0 4px 15px rgba(0, 169, 196, 0.5);
                        transition: all 0.3s ease;
                        z-index: 2;

                        svg {
                            width: 40px;
                            height: 40px;
                            margin-left: 4px;
                        }
                    }

                    .detail-title {
                        position: absolute;
                        bottom: 40px;
                        left: 40px;
                        right: 40px;
                        z-index: 3;

                        h3 {
                            margin: 0;
                            color: #fff;
                            font-size: 2em;
                            font-weight: 700;
                            line-height: 1.3;
                            text-shadow: 0 2px 10px rgba(0,0,0,0.5);
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;

                            @media (max-width: 768px) {
                                font-size: 1.4em;
                                bottom: 20px;
                                left: 20px;
                                right: 20px;
                            }
                        }
                    }
                    
                    &:hover img {
                        opacity: 1;
                        transform: scale(1.05);
                    }

                    &:hover .play-button-overlay {
                        background: #00A9C4;
                        transform: translate(-50%, -50%) scale(1.1);
                        box-shadow: 0 6px 20px rgba(0, 169, 196, 0.8);
                    }
                }
            }
        }
    `,
    ModalOverlay: styled.div`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.85);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        backdrop-filter: blur(5px);
        animation: fadeIn 0.3s ease;

        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }

        .modal-content {
            position: relative;
            width: 90%;
            max-width: 1000px;
            background: #000;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 0 40px rgba(0, 169, 196, 0.4);
            animation: slideUp 0.4s ease;

            @keyframes slideUp {
                from { transform: translateY(50px); opacity: 0; }
                to { transform: translateY(0); opacity: 1; }
            }
        }

        .close-btn {
            position: absolute;
            top: 15px;
            right: 15px;
            background: rgba(255, 255, 255, 0.2);
            border: none;
            color: white;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 10;
            transition: all 0.3s ease;

            &:hover {
                background: #00A9C4;
                transform: rotate(90deg);
            }

            svg {
                width: 24px;
                height: 24px;
            }
        }

        .modal-video-wrapper {
            position: relative;
            padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
            height: 0;
            
            iframe {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }
    `
};

export default S;